<template>
    <div class="row details-container" v-if="readyToRender">
        <div class="col-md-4 left-bloc">
        <p>
            Créé le {{ lead.created_at | moment-date }} <span v-if="lead.creating_user != null && lead.creating_user.email"> par {{ lead.creating_user.email }} </span>
            <br>depuis {{ lead.decoded_origin }}
        </p>
        <p v-if="lead.origin_message">Message : <br>
        {{lead.origin_message}}
        </p>
        </div>
        <div class="col-md-4 block--center">
            <div v-if="lead.lead_distribution_methods.length" style="font-weight: bold; margin-bottom: 10px;">Intéréssé par les types d'offres suivants</div>
            <ul v-if="lead.lead_distribution_methods.length">
                <li v-for="(lead_distribution_method, idx) in lead.lead_distribution_methods" :key="'distribution_methods_' + idx">
                    <p>{{ lead_distribution_method.distribution_method.display_name }}</p>
                    <p class="created_at">{{ lead_distribution_method.created_at | moment-date-time}}</p>
                </li>
            </ul>
        </div>
        <div class="col-md-4 right-bloc">
            <div v-if="lead_offers.length" style="font-weight: bold; margin-bottom: 10px;">Intéréssé par les offres suivantes</div>
            <ul v-if="lead_offers.length">
                <li v-for="(lead_offer, idx_offer) in lead_offers" :key="'lead_offer_' + idx_offer">
                    <p>{{lead_offer.offer.name}} / {{lead_offer.offer.distributed_product.agency.name}}</p>
                    <p class="created_at">{{ lead_offer.created_at | moment-date-time}}</p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions, mapState} from "vuex"

export default {
  name:"LeadItemDetails",
  props:["lead", "idx"],
  computed:{
    ...mapState("crm", ["users"]),

    readyToRender()
    {
      if (this.lead )
        return true
      return false
    },

    lead_offers() {
      return this.lead.lead_offers
    }
  },

  methods:{
    ...mapActions("crm", ["set_fetching_state"]),

    get_email_of(cid){
      var found = _.find(this.users, u => {
        return u.id === cid
      })
      return found != undefined ? found.email : null
    },
  },
}
</script>

<style scoped>
p {
  margin-bottom: 0;
}

.details-container {
    display: flex;
    background-color: #f0f0f0;
}

.left-bloc {
  padding: 20px;
  margin-left: 55px;
}

.block--center {
    padding: 20px;
}

.right-bloc {
  padding: 20px;
  margin-right: 55px;
}

.created_at {
  color: #999;
  font-style: italic;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// client/components/CRM/LeadItemDetails.vue